<svg *ngIf="iconName">
    <use [attr.xlink:href]="icon" [attr.href]="icon"></use>
</svg>
